import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from './AuthContext';
import {
  canAccessFacility,
  accessibleFacilityIds,
} from '../config/facilityAccess';

const FacilityContext = createContext();

export const useFacility = () => useContext(FacilityContext);

export const FacilityProvider = ({ children }) => {
  const { claims } = useAuth();

  const [facilityId, setFacilityId] = useState(() => {
    return localStorage.getItem('facilityId');
  });

  useEffect(() => {
    if (facilityId) {
      localStorage.setItem('facilityId', facilityId);
    } else {
      setFacilityId(localStorage.getItem('facilityId'));
    }
  }, [facilityId]);

  useEffect(() => {
    const allowed = accessibleFacilityIds(claims);
    if (facilityId && allowed.length > 0 && !canAccessFacility(claims, facilityId)) {
      setFacilityId(allowed[0]);
    }
  }, [claims, facilityId]);

  return (
    <FacilityContext.Provider value={{ facilityId, setFacilityId }}>
      {children}
    </FacilityContext.Provider>
  );
};

FacilityProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
